import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";

export default function AffichesGallery() {
  const [sites, setSites] = useState([]);
  useEffect(() => {
    api.get("/sites").then((r) => setSites(r.data.filter((s) => s.poster))).catch(() => {});
  }, []);

  if (sites.length === 0) return null;

  return (
    <section className="relative py-32 md:py-40 px-6 md:px-12 bg-bg overflow-hidden" data-testid="affiches-gallery">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid md:grid-cols-12 gap-12 mb-16 md:mb-20">
          <div className="md:col-span-7">
            <div className="meta-label text-cinabre">§ Affiches provisoires · Canal'Art 2026</div>
            <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight mt-6">
              Une identité par <em className="italic">escale</em>.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 self-end">
            <p className="text-fg/75 leading-relaxed text-lg">
              Six sites, six atmosphères. Les affiches signent chaque escale du Fil — de la brique rose de Toulouse aux miroirs mouvants de l'Étang de Thau.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {sites.map((s, i) => (
            <motion.figure
              key={s.slug}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.9, delay: (i % 4) * 0.06, ease: [0.65, 0, 0.35, 1] }}
              className="group"
              data-testid={`affiche-${s.slug}`}
            >
              <div className="relative overflow-hidden border border-fg/15 bg-fg/5 aspect-[2/3]">
                <img
                  src={s.poster}
                  alt={`Affiche Canal'Art 2026 — ${s.name}`}
                  className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-fg/0 group-hover:bg-fg/10 transition-colors duration-500" />
              </div>
              <figcaption className="mt-4 flex items-baseline justify-between gap-3">
                <div>
                  <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-cinabre">Chapitre {s.chapter}</div>
                  <div className="font-serif text-xl md:text-2xl leading-tight mt-1">{s.name}</div>
                </div>
                <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-fg/60 shrink-0">{s.km}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <p className="mt-14 font-mono text-[10px] tracking-[0.24em] uppercase text-fg/50 max-w-2xl">
          Visuels provisoires — validation finale VNF · UNESCO · Les Arteurs · en cours.
        </p>
      </div>
    </section>
  );
}
